export const DATE_FIELD_NAMES = new Set(['timestamp']);

export const dateAwareDataDeserializer = (data: unknown, key?: string): unknown => {
  if (Array.isArray(data)) {
    return data.map((item: unknown) => dateAwareDataDeserializer(item));
  }
  if (typeof data === 'object' && data !== null) {
    return Object.fromEntries(Object.entries(data).map(([k, value]) => [k, dateAwareDataDeserializer(value, k)]));
  }
  if (typeof data === 'string' && key !== undefined && DATE_FIELD_NAMES.has(key) && !isNaN(Date.parse(data))) {
    return new Date(data);
  }
  return data;
};
